import { useState } from 'react'
import { Tabs, Tab, Button, KpiCard } from '@/components/ui'
import { Users, DollarSign, MessageSquare, TrendingUp, Plus, LayoutGrid, Wand2, SlidersHorizontal, Receipt } from 'lucide-react'
import { CampanasActivas } from './Activas'
import { CampanasCrear } from './Crear'
import { CampanasVariables } from './Variables'
import { CampanasCostos } from './Costos'
import { campanas } from '@/mock'
import { fmtMoney, fmtNumber } from '@/lib/utils'

type TabKey = 'activas' | 'crear' | 'variables' | 'costos'

export function CampanasPage() {
  const [tab, setTab] = useState<TabKey>('activas')

  const activas = campanas.filter(c => c.estado === 'activa').length
  const personasHoy = campanas.filter(c => c.estado === 'activa').reduce((a, c) => a + c.stats.personasHoy, 0)
  const respondieronHoy = campanas.reduce((a, c) => a + c.stats.respondieronHoy, 0)
  const costoHoy = campanas.filter(c => c.estado === 'activa').reduce((a, c) => a + c.stats.personasHoy * 0.0125, 0)

  return (
    <div className="space-y-5">
      <header className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="text-xs uppercase tracking-widest text-blue-500 font-semibold">WhatsApp · Campañas</div>
          <h1 className="font-display text-3xl text-navy-700 leading-tight">Campañas automatizadas</h1>
          <p className="text-sm text-slate-500 max-w-2xl mt-1">
            Envío masivo priorizado por tipo (preventiva · mora · reenvío) con reglas, tandas, templates aprobados Meta y simulador antes de disparar.
          </p>
        </div>
        <Button variant="amber" onClick={() => setTab('crear')}>
          <Plus className="w-4 h-4" /> Nueva campaña
        </Button>
      </header>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <KpiCard
          label="Campañas activas"
          value={fmtNumber(activas)}
          sub={`${campanas.length - activas} pausadas/borrador`}
          icon={<LayoutGrid className="w-3.5 h-3.5" />}
          color="emerald"
        />
        <KpiCard
          label="Personas a contactar hoy"
          value={fmtNumber(personasHoy)}
          sub="suma todas activas"
          icon={<Users className="w-3.5 h-3.5" />}
        />
        <KpiCard
          label="Respondieron hoy"
          value={fmtNumber(respondieronHoy)}
          sub={`${personasHoy > 0 ? Math.round((respondieronHoy / personasHoy) * 100) : 0}% tasa`}
          icon={<MessageSquare className="w-3.5 h-3.5" />}
          color="emerald"
        />
        <KpiCard
          label="Costo total hoy"
          value={fmtMoney(costoHoy)}
          sub="USD · tarifa Meta"
          icon={<DollarSign className="w-3.5 h-3.5" />}
          color="amber"
        />
      </div>

      <Tabs value={tab} onChange={v => setTab(v as TabKey)} color="blue">
        <Tab value="activas" icon={<LayoutGrid className="w-4 h-4" />}>Activas</Tab>
        <Tab value="crear" icon={<Wand2 className="w-4 h-4" />}>Crear</Tab>
        <Tab value="variables" icon={<SlidersHorizontal className="w-4 h-4" />}>Variables</Tab>
        <Tab value="costos" icon={<Receipt className="w-4 h-4" />}>Costos</Tab>
      </Tabs>

      <div className="view-transition">
        {tab === 'activas' && <CampanasActivas />}
        {tab === 'crear' && <CampanasCrear />}
        {tab === 'variables' && <CampanasVariables />}
        {tab === 'costos' && <CampanasCostos />}
      </div>
    </div>
  )
}
